import AsyncStore from './AsyncStore';
import { IAsyncStoreSettings } from './types';

const AsyncStoreFactory = <T>(settings: IAsyncStoreSettings<T>) =>
  new AsyncStore<T>(settings);

export default AsyncStoreFactory;
